import queryString from "query-string";

export const getResponseFromHash = hash => {
  return queryString.parse(hash);
};

export const getResponseFromSearch = search => {
  return queryString.parse(search);
};

export const hashStateStartsWith = (hash, compare) => {
  if (hash) {
    const response = getResponseFromHash(hash);

    if (response.state) {
      return response.state.startsWith(compare);
    }
  }

  return false;
};



// WEBPACK FOOTER //
// ./src/helpers/Location.js